import { useEffect, useState } from 'react';

import { getCountdownDuration } from 'utils';

const useCountdown = (endDate: string) => {
  const [duration, setDuration] = useState(() => getCountdownDuration(endDate));

  useEffect(() => {
    const durationInterval = setInterval(() => {
      setDuration(() => getCountdownDuration(endDate));
    }, 1_000);

    return () => {
      clearInterval(durationInterval);
    };
  }, [endDate]);

  return { duration };
};

export default useCountdown;
